import React from "react";
import { Link } from "react-router-dom";
import { usePageMeta } from "../hooks/usePageMeta";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl md:text-2xl font-black text-[#0a2a5e] mb-3">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function TermsOfUse() {
  usePageMeta("Terms of Use", "The terms and conditions governing your use of the Baishalii Tanks & Pipes website.");
  return (
    <div className="pt-[88px] md:pt-[112px]" data-testid="terms-of-use-page">
      <section className="relative py-20 bg-gradient-to-r from-[#061a3d] via-[#0a2a5e] to-sky-700 text-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl sm:text-5xl font-black">Terms of Use</h1>
          <p className="text-sky-200 mt-4">Last updated: July 2026</p>
        </div>
      </section>
      <section className="py-14 md:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <Section title="1. Acceptance of Terms">
            <p>
              By accessing or using this website, you agree to these Terms of Use. If you do not agree, please do not
              use the website. The website is owned and operated by Baishalii Tanks &amp; Pipes ("BAISHALII", "we",
              "us").
            </p>
          </Section>
          <Section title="2. Use of the Website">
            <p>
              You may browse this website for information about our products and to contact us for genuine business
              enquiries. You agree not to misuse the website, attempt unauthorised access, or use automated tools to
              scrape or overload it.
            </p>
          </Section>
          <Section title="3. Product Information">
            <p>
              Product specifications, sizes, colours and images shown on this website are indicative and may be
              updated or improved without prior notice. Actual products may vary slightly from the images shown.
              Please confirm final specifications with our sales team or an authorised dealer before purchase.
            </p>
          </Section>
          <Section title="4. Intellectual Property">
            <p>
              The BAISHALII name, logo, product names, images and all content on this website are the property of
              Baishalii Tanks &amp; Pipes. You may not reproduce, distribute or use them for commercial purposes
              without our prior written permission.
            </p>
          </Section>
          <Section title="5. No Warranty for Website Content">
            <p>
              While we strive to keep the information accurate and current, the website is provided "as is" without
              warranties of any kind regarding completeness or accuracy. Product warranties, where applicable, are
              provided separately with the product and per our published warranty terms.
            </p>
          </Section>
          <Section title="6. Limitation of Liability">
            <p>
              To the maximum extent permitted by law, BAISHALII shall not be liable for any indirect or consequential
              loss arising from the use of, or inability to use, this website.
            </p>
          </Section>
          <Section title="7. Third-Party Links & Services">
            <p>
              The website may contain links to or integrations with third-party services (such as WhatsApp chat).
              These are governed by the respective third party's own terms, and we are not responsible for their
              content or practices.
            </p>
          </Section>
          <Section title="8. Governing Law">
            <p>
              These terms are governed by the laws of India. Any disputes shall be subject to the exclusive
              jurisdiction of the courts at Kolkata, West Bengal.
            </p>
          </Section>
          <Section title="9. Contact">
            <p>
              For any questions regarding these terms, write to{" "}
              <a href="mailto:contact@baishalii.in" className="text-sky-600 hover:underline">contact@baishalii.in</a>{" "}
              or call our toll-free line 1800 202 3360.
            </p>
          </Section>
          <Link to="/privacy-policy" data-testid="terms-privacy-link" className="text-sky-600 font-semibold hover:underline">
            Read our Privacy Policy →
          </Link>
        </div>
      </section>
    </div>
  );
}
